module.exports = __webpack_public_path__ + "img/media-pic-4.f1188bc1.png";